import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';

const tz = 'Asia/Shanghai';

// 加载插件
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault(tz);

export default dayjs;
